import React from 'react';
import icon from '../img/info.svg';
import DatePicker from 'react-pikaday-component';
import arrow from '../img/circle-arrow-left.svg';

const i18n = {
    previousMonth : 'Zurück',
    nextMonth     : 'Weiter',
    months        : ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
    weekdays      : ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
    weekdaysShort : ['So','Mo','Di','Mi','Do','Fr','Sa']
}

class ReceiptDateInput extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            choice: props.receiptDate,
        }
    }

    render() {
        const props = this.props;
        const { choice } = this.state;

        return (
            <article className={`question q1 slide-${props.position}`}>
                <div className={`inner`}>
                    <div className="question__text">
                        <span>Wann war der Zugang der Kündigung?</span>
                    </div>
                    <div className="question__field">
                        <DatePicker 
                            i18n={i18n}
                            firstDay={1}
                            value={choice}
                            position="top left"
                            maxDate={new Date()}
                            format="DD.MM.YYYY"
                            placeholder="TT.MM.JJJJ"
                            onChange={(day) => this.setState({ choice: day })}
                        />
                    </div>
                </div>
                <div className="inner question__controls">
                    <div className="question__control">
                        <a className="question__back-link" 
                            onClick={props.showPreviousField}>
                                <img src={arrow} />
                        </a>
                    </div>
                    <div className="question__control">
                        <span data-tip data-for="receipt-date" className="question__info-icon">
                            <img src={icon} />
                        </span>
                    </div>
                    <div className="question__control">
                        <a tabIndex={ choice ? "2" : "-1" }
                            onClick={() => props.updateReceiptDate(choice)}
                            className={`question__next-link ${!choice ? 'hidden' : ''}`}>
                                <img src={arrow} />
                        </a>
                    </div>
                </div>
            </article>
        );
    }
}

export default ReceiptDateInput;


// WEBPACK FOOTER //
// ./src/components/input.receipt-date.js